module.exports = (fox) => {
	const TITLE = 'Please fill in your credit card details below to proceed with the payment';
	const argumentError = new Error('[CBPaymentPopup widget]: -> show method requires promise argument.');
	const windowId = 'cb_payment_window';

	fox.registerWidget('CBPaymentPopup', {
		configure() {
			this.registerOptions('', {
				handleWom: {
					closeCallback: {
						event: 'inboxSocketEventBilling:popup:close',
						widget: '@root #socket',
						callback: 'closeCallback'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init() {
			this._isSupportPopup = /(Chrom(e|ium)|Firefox|AppleWebKit)/.test(navigator.userAgent);

			this._window = null;
			this.matchToken = this.getOption('matchTokenFunction') || null;

			this.callParent('init', arguments);
		},

		hide() {
			if (this._window) {
				this._window.close();
				this._window = null;

				return true;
			}

			return false;
		},

		_createPopup() {
			const id = `${windowId}_${new Date().getTime()}`;
			const _window = window.open(
				'',
				id, 
				!this._isSupportPopup ? '' : 'width=120,height=120,resizable=yes,location=no,scrollbars=yes,status=no'
			);
			
			_window.document.write(`
				<div style="text-align:center;">
					<img src="https://purchase.centrobill.com/template/paypage/sps_ajx_en/img/loading.gif" />
				</div>
			`);

			return _window;
		},

		show(promise) {
			if (!fox.isPromise(promise))
				throw argumentError;

			if (this.isOpen())
				this.hide();

			let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

			this._window = iOS ? window : this._createPopup();

			return promise.then((resp) => {
				const { url } = resp;

				if (!this._window)
					return resp;

				this._window.location.href = url;

				if (this._isSupportPopup)
					this._window.resizeTo(700, 850);

				return resp;
			});
		},

		isOpen() {
			return this._window ? !this._window.closed : false;
		},

		closeCallback(resp) {
			var parent = this.getParent();

			if (this.isOpen()) {
				var memberInfo = fox.site.rwom1('.PermissionManager').getMemberInfo();
				var useToken = fox.isFunction(this.matchToken) && this.matchToken(resp.answer.token);

				if (!fox.isEmpty(memberInfo) || useToken) {
					this.hide();

					if (useToken && fox.isFunction(parent.showSuccessPopup))
						parent.hookWrapper('showSuccessPopup');
				}
			}
		}
	}, 'Controller');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/cbPaymentPopup.es.js